import React, { useState, useEffect, useMemo } from "react";
import {
  Button, Dialog, DialogActions, DialogContent, Select, TableContainer, Paper,
  TableRow, Table, TableHead, TableBody, TableCell, FormControl, MenuItem, Box,
  Typography, IconButton, FormHelperText, Card, TextField, InputAdornment, Tooltip, Chip,
} from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import FilterListIcon from '@material-ui/icons/FilterList';
import SchoolIcon from '@material-ui/icons/School';
import SuperActivityService from "./Locality/Service/superActivityService";
import AddClassService from "./Locality/Service/addClassService";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import { canEditDeleteActivityRow } from "../../utils/activityRowPermissions";
import { getDashboardPageStyles } from "../../utils/dashboardPageStyles";
import {
  buildListSchoolRequest,
  buildScopedListBody,
  effectiveSchoolIdForWrite,
  filterRowsBySchoolScope,
  getUserDetails,
  resolveRowSchoolId,
  resolveSchoolId,
  resolveSchoolIdForClass,
  resolveRowSchoolLabel,
  isSchoolAddedRow,
  shouldShowSchoolColumn,
} from "../../utils/activityCatalogScope";

const useStyles = makeStyles((theme) => ({
  ...getDashboardPageStyles(theme),
}));

const tableHeaders = ['Class', 'Area Of Work', 'Add More', 'Actions'];

export default function SuperActivity({ embedded = false, scope = null, sharedClassList = null }) {
    const classes = useStyles();
    const userDetails = useMemo(
        () => scope?.userDetails || getUserDetails(),
        [scope]
    );
    const useExternalScope = embedded && scope != null;
    const scopeSchoolId = scope?.filterSchoolId ?? '';
    const scopeClassId = scope?.filterClassId ?? '';
    const [superActivityList, setSuperActivityList] = useState([]);
    const [age, setAge] = React.useState('');
    const [tabelIdList, setTabelIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [pendingDelete, setPendingDelete] = useState(null);
    const [tabel, setTabel] = useState({
        superActivityName: '',
        classId:'',
        schooleId: '',
    });
    const [addClassList, setAddClassList] = useState([]);
    const [noteOpen, setNoteOpen] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterClassId, setFilterClassId] = useState('');
    const [pg, setPg] = useState(0);
    const [rpg, setRpg] = useState(10);
    const validationSchema = Yup.object().shape({
        superActivityName: Yup.string().required('Super Activity Name is required'),
    });
    useEffect(() => {
        getSuperActivityList();
        if (!sharedClassList) {
            getAddClassList();
        }
        return () => {
            setTabelIdList([]);
            setSuperActivityList([]);
        }
    }, [scopeSchoolId, scopeClassId, useExternalScope, sharedClassList]);

    useEffect(() => {
        if (sharedClassList) {
            setAddClassList(sharedClassList);
        }
    }, [sharedClassList]);
    const scopedSchoolId = () =>
        effectiveSchoolIdForWrite(userDetails, useExternalScope ? scopeSchoolId : '');

    const handleOpen = (status) => {
        if(status){
            const nextClassId = useExternalScope ? (scopeClassId || '') : '';
            setTabel({
                superActivityName: '',
                classId: nextClassId,
                schooleId: resolveSchoolIdForClass(
                    addClassList,
                    nextClassId,
                    useExternalScope ? scopeSchoolId : '',
                    userDetails
                ),
        })
        }
     
          setOpen(true);
      };
    const handleClose = () => {
        setOpen(false);
    };
    const getAddClassList = () => {
        const { listId, role } = buildListSchoolRequest(userDetails, useExternalScope ? scopeSchoolId : resolveSchoolId(userDetails));
        if (!listId) return;
        AddClassService.getAllAddClass(listId, role).then((res) => {
            setAddClassList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getSuperActivityList = () => {
        const { listId, role } = buildListSchoolRequest(userDetails, useExternalScope ? scopeSchoolId : resolveSchoolId(userDetails));
        if (!listId) return;
        SuperActivityService.getAllSuperActivity(listId, role).then((res) => {
            const rows = filterRowsBySchoolScope(
                Array.isArray(res) ? res : [],
                useExternalScope ? scopeSchoolId : ''
            );
            setSuperActivityList(rows);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    // const getAddClassList = () => {
    //     const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    //     AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
    //         setAddClassList(res);
    //     }).catch((err) => {
            
    //     });
    // }
    // const getClassNameList = (event) => {
    //     AddClassService.getAddClassNameById({ className: event.target.value }).then((res) => {
          
    //         setClassNameList(res);

    //     }).catch((err) => {
    //         setError(err.message);
    //     });
    // }
    const editActivityTabel = (tabel) => {
        const obj = JSON.parse(JSON.stringify(tabel));
        obj.superActivityId = tabel.superActivityId ? tabel.superActivityId._id : '';
        obj.classId = tabel.classId ? tabel.classId._id :'';
        obj.schooleId = resolveRowSchoolId(tabel) || resolveSchoolIdForClass(
            addClassList,
            obj.classId,
            useExternalScope ? scopeSchoolId : '',
            userDetails
        );
        // obj.activityId = sub.activityId ? sub.activityId._id : '';
        setTabel(obj)
        handleOpen(false)
    }
    const addAreaFromRow = (row) => {
        const nextClassId = row.classId ? (row.classId._id || row.classId) : '';
        setTabel({
            superActivityName: '',
            classId: nextClassId,
            schooleId: resolveRowSchoolId(row) || resolveSchoolIdForClass(
                addClassList,
                nextClassId,
                useExternalScope ? scopeSchoolId : '',
                userDetails
            ),
        });
        setOpen(true);
    };
    const deleteActivityTabel = (tabeldelete) => {
        if (!tabeldelete) return;
        setPendingDelete(tabeldelete);
        setDeleteConfirmOpen(true);
    };
    const confirmDelete = async () => {
        const row = pendingDelete;
        setDeleteConfirmOpen(false);
        setPendingDelete(null);
        if (!row) return;
        try {
            await SuperActivityService.deleteSuperActivity(row);
            getSuperActivityList();
        } catch {
            // ignore
        }
    };
    const formik = useFormik({
        initialValues: tabel,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            values.schooleId = values.schooleId || resolveSchoolIdForClass(
                addClassList,
                values.classId,
                useExternalScope ? scopeSchoolId : '',
                userDetails
            ) || scopedSchoolId();
            if (!values.schooleId) {
                alert('Please select a school in the scope filters before adding an area of work.');
                return;
            }
            if (tabel._id) {
                SuperActivityService.upadeSuperActivity(values).then((res) => {
                    handleClose();
                    getSuperActivityList();
                    resetForm()
                    alert("Super Activity Updated Successfully.");
                }).catch((err) => {
                });
            }
            else {
                SuperActivityService.creteSuperActivity(values).then((res) => {
                    getSuperActivityList();
                    resetForm();
                    handleClose();
                    alert("Super Activity Added Successfully.");
                    // props.history.push('/app/vendor');
                })
                    .catch((err) => {
                        
                        alert(err.response.data.message)
                    })
            }

        },
    });

    const effectiveClassFilter = useExternalScope ? scopeClassId : filterClassId;
    const showSchoolColumn = shouldShowSchoolColumn(embedded, scope);
    const displayHeaders = useMemo(
        () => (showSchoolColumn ? ['School', ...tableHeaders] : tableHeaders),
        [showSchoolColumn]
    );

    const renderSchoolCell = (row) => {
        if (!isSchoolAddedRow(row)) {
            return <Typography variant="caption" style={{ color: '#9aa6b6' }}>Default</Typography>;
        }
        const label = resolveRowSchoolLabel(row, addClassList);
        return label ? (
            <Chip size="small" icon={<SchoolIcon style={{ fontSize: 14 }} />} label={label} className={classes.classChip} />
        ) : (
            <Typography variant="caption" style={{ color: '#9aa6b6' }}>—</Typography>
        );
    };

    const filteredList = useMemo(() => {
        const term = searchTerm.trim().toLowerCase();
        const scoped = filterRowsBySchoolScope(
            superActivityList,
            useExternalScope ? scopeSchoolId : ''
        );
        return scoped.filter((row) => {
            if (effectiveClassFilter) {
                const cid = row.classId?._id || row.classId;
                if (String(cid) !== String(effectiveClassFilter)) return false;
            }
            if (!term) return true;
            const cls = (row.classId?.className || '').toLowerCase();
            const name = (row.superActivityName || '').toLowerCase();
            return cls.includes(term) || name.includes(term);
        });
    }, [superActivityList, searchTerm, effectiveClassFilter, useExternalScope, scopeSchoolId]);

    const handleResetFilters = () => {
        if (!useExternalScope) {
            setFilterClassId('');
        }
        setSearchTerm('');
        setPg(0);
        getSuperActivityList();
    };

    const renderDeleteDialog = () => (
        <Dialog
            open={deleteConfirmOpen}
            onClose={() => { setDeleteConfirmOpen(false); setPendingDelete(null); }}
            maxWidth="xs"
            fullWidth
            PaperProps={{ className: classes.dialogPaper }}
        >
            <Box className={classes.dialogTitleBar}>
                <span className={classes.dialogTitleText}>Confirm Delete</span>
                <IconButton size="small" onClick={() => { setDeleteConfirmOpen(false); setPendingDelete(null); }}>
                    <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
                </IconButton>
            </Box>
            <DialogContent className={classes.dialogBody}>
                <Typography variant="body2" style={{ color: '#46566b', lineHeight: 1.6 }}>
                    Are you sure you want to delete{' '}
                    <strong>{pendingDelete?.superActivityName || 'this area of work'}</strong>?
                    All related list of activities and exercises under this area will also be deleted.
                    This action cannot be undone.
                </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogFooter}>
                <Button onClick={() => { setDeleteConfirmOpen(false); setPendingDelete(null); }} className={classes.cancelBtn}>Cancel</Button>
                <Button onClick={confirmDelete} variant="contained" className={classes.saveBtn} style={{ backgroundColor: '#c62828' }}>Delete</Button>
            </DialogActions>
        </Dialog>
    );

    return (
        <Box className={embedded ? undefined : classes.pageWrapper}>
            {!embedded && (
            <Box className={classes.pageHeader}>
                <Box>
                    <Typography className={classes.pageTitle}>Area Of Work</Typography>
                    <Typography className={classes.pageSubtitle}>
                        Manage Montessori area-of-work categories by class. Add custom areas beyond the defaults.
                    </Typography>
                </Box>
                <Button variant="contained" className={classes.primaryBtn} startIcon={<AddIcon />} onClick={() => handleOpen(true)}>
                    Add Area Of Work
                </Button>
            </Box>
            )}

            {!embedded && noteOpen && (
                <Box className={classes.noteBanner}>
                    <Box className={classes.noteIconWrap}><InfoOutlinedIcon style={{ fontSize: 18 }} /></Box>
                    <Box flex={1}>
                        <Typography style={{ fontWeight: 600, color: '#1f3a5f', fontSize: '0.9rem' }}>Area of work</Typography>
                        <Typography style={{ color: '#46566b', fontSize: '0.85rem', marginTop: 2 }}>
                            By default, all area of work, activities, and exercises are added. Add extra areas here if needed.
                        </Typography>
                    </Box>
                    <IconButton size="small" onClick={() => setNoteOpen(false)}><CloseIcon style={{ fontSize: 18, color: '#7a8aa0' }} /></IconButton>
                </Box>
            )}

            {!useExternalScope && (
            <Card elevation={0} className={classes.filtersCard}>
                <Box className={classes.filtersHeader}>
                    <Box display="flex" alignItems="center" gridGap={8}>
                        <FilterListIcon style={{ fontSize: 18, color: '#1769d6' }} />
                        <Typography style={{ fontWeight: 700, color: '#0f2d4d', fontSize: '0.9rem' }}>Filters</Typography>
                    </Box>
                    <Button size="small" className={classes.resetBtn} onClick={handleResetFilters}>Reset</Button>
                </Box>
                <Box className={classes.filtersBody}>
                    <FormControl variant="outlined" size="small" fullWidth style={{ maxWidth: 320 }}>
                        <Typography className={classes.filterLabel}><SchoolIcon style={{ fontSize: 16, color: '#1769d6' }} /> Class</Typography>
                        <Select value={filterClassId} onChange={(e) => { setFilterClassId(e.target.value); setPg(0); }} displayEmpty>
                            <MenuItem value=""><em>All Classes</em></MenuItem>
                            {addClassList.map(({ _id, className }) => (
                                <MenuItem key={_id} value={_id}>{className}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </Card>
            )}

            <Card elevation={0} className={embedded ? classes.embeddedTableCard : classes.tableCard}>
                <Box className={classes.toolbar}>
                    <Typography style={{ fontWeight: 700, color: '#0f2d4d' }}>
                        {filteredList.length} Area{filteredList.length !== 1 ? 's' : ''} Of Work
                    </Typography>
                    <Box display="flex" alignItems="center" gridGap={10}>
                        {embedded && (
                            <Button variant="contained" className={classes.primaryBtn} size="small" startIcon={<AddIcon />} onClick={() => handleOpen(true)}>
                                Add Area Of Work
                            </Button>
                        )}
                        <TextField
                            size="small" variant="outlined" placeholder="Search…" value={searchTerm}
                            onChange={(e) => { setSearchTerm(e.target.value); setPg(0); }}
                            InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon style={{ fontSize: 18, color: '#9aa6b6' }} /></InputAdornment> }}
                        />
                        <Tooltip title="Refresh"><IconButton className={classes.iconBtnOutlined} size="small" onClick={getSuperActivityList}><RefreshIcon style={{ fontSize: 20, color: '#46566b' }} /></IconButton></Tooltip>
                    </Box>
                </Box>
                <TableContainer component={Paper} elevation={0} style={{ maxHeight: 520 }}>
                    <Table stickyHeader size="small" className="dashboard-table-row-hover">
                        <TableHead>
                            <TableRow>
                                {displayHeaders.map((key) => <TableCell key={key} className={classes.headCell}>{key}</TableCell>)}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredList.length === 0 && (
                                <TableRow><TableCell colSpan={displayHeaders.length} align="center" style={{ padding: 48, color: '#7a8aa0' }}>No areas of work found.</TableCell></TableRow>
                            )}
                            {filteredList.slice(pg * rpg, pg * rpg + rpg).map((row) => (
                                <TableRow key={row._id} hover>
                                    {showSchoolColumn && (
                                        <TableCell>{renderSchoolCell(row)}</TableCell>
                                    )}
                                    <TableCell>
                                        {row.classId?.className ? (
                                            <Chip size="small" icon={<SchoolIcon style={{ fontSize: 14 }} />} label={row.classId.className} className={classes.classChip} />
                                        ) : '—'}
                                    </TableCell>
                                    <TableCell>
                                        <Chip size="small" label={row.superActivityName || '—'} className={classes.areaChip} />
                                    </TableCell>
                                    <TableCell align="center">
                                        <Tooltip title="Add another area of work for this class">
                                            <IconButton
                                                className={classes.iconAction}
                                                size="small"
                                                onClick={() => addAreaFromRow(row)}
                                            >
                                                <AddIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        <Box display="flex" alignItems="center">
                                            {canEditDeleteActivityRow(row) ? (
                                                <>
                                                    <Tooltip title="Edit"><IconButton className={classes.iconAction} size="small" onClick={() => editActivityTabel(row)}><EditIcon fontSize="small" /></IconButton></Tooltip>
                                                    <Tooltip title="Delete"><IconButton className={classes.deleteIcon} size="small" onClick={() => deleteActivityTabel(row)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>
                                                </>
                                            ) : (
                                                <>
                                                    <EditIcon className={classes.disabledIcon} fontSize="small" title="System activities cannot be edited" />
                                                    <DeleteIcon className={classes.disabledIcon} fontSize="small" title="System activities cannot be deleted" />
                                                </>
                                            )}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination component="div" count={filteredList.length} page={pg} onPageChange={(_, p) => setPg(p)} rowsPerPage={rpg} onRowsPerPageChange={(e) => { setRpg(parseInt(e.target.value, 10)); setPg(0); }} rowsPerPageOptions={[5, 10, 25, 50]} />
            </Card>

            <Dialog open={open} onClose={handleClose} scroll="paper" fullWidth maxWidth="xs" PaperProps={{ className: classes.dialogPaper }}>
                <Box className={classes.dialogTitleBar}>
                    <span className={classes.dialogTitleText}>
                        {tabel._id ? 'Edit Area Of Work' : 'Add Area Of Work'}
                    </span>
                    <IconButton size="small" onClick={handleClose}>
                        <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
                <form onSubmit={formik.handleSubmit}>
                    <DialogContent className={classes.dialogBody}>
                        <Box style={{ marginBottom: 16 }}>
                            <span className={classes.fieldLabel}>Class</span>
                            <FormControl
                                variant="outlined" size="small" fullWidth
                                error={formik.touched.classId && Boolean(formik.errors.classId)}
                            >
                                <Select
                                    id="demo-simple-select"
                                    name="classId"
                                    displayEmpty
                                    value={formik.values.classId}
                                    onChange={(e) => {
                                        formik.handleChange(e);
                                        const sid = resolveSchoolIdForClass(
                                            addClassList,
                                            e.target.value,
                                            useExternalScope ? scopeSchoolId : '',
                                            userDetails
                                        );
                                        if (sid) formik.setFieldValue('schooleId', sid);
                                    }}
                                >
                                    <MenuItem value=""><em>Select Class</em></MenuItem>
                                    {addClassList.map(({ _id, className }) => (
                                        <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                    ))}
                                </Select>
                                {formik.touched.classId && formik.errors.classId && (
                                    <FormHelperText>{formik.errors.classId}</FormHelperText>
                                )}
                            </FormControl>
                        </Box>
                        <Box>
                            <span className={classes.fieldLabel}>Area Of Work</span>
                            <TextField
                                fullWidth size="small" variant="outlined"
                                autoFocus
                                id="superActivityName"
                                name="superActivityName"
                                type="text"
                                value={formik.values.superActivityName}
                                onChange={formik.handleChange}
                                error={formik.touched.superActivityName && Boolean(formik.errors.superActivityName)}
                                helperText={formik.touched.superActivityName && formik.errors.superActivityName}
                            />
                        </Box>
                    </DialogContent>
                    <DialogActions className={classes.dialogFooter}>
                        <Button onClick={handleClose} className={classes.cancelBtn}>Cancel</Button>
                        <Button type="submit" variant="contained" className={classes.saveBtn}>
                            {tabel._id ? 'Update' : 'Add'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>

            {renderDeleteDialog()}
        </Box>
    );
}
